import { supabase } from "./supabase";

export interface WaterLog {
  id: string;
  logged_at: string;
  amount_ml: number;
}

export const GLASS_ML = 240;
export const DEFAULT_GLASSES_TARGET = 8;

export async function loadTodayWater(): Promise<WaterLog[]> {
  if (!supabase) return [];
  const since = startOfToday().toISOString();
  const { data, error } = await supabase
    .from("water_logs")
    .select("*")
    .gte("logged_at", since)
    .order("logged_at", { ascending: true });
  if (error) throw error;
  return (data ?? []).map((r) => ({
    id: r.id,
    logged_at: r.logged_at,
    amount_ml: r.amount_ml
  }));
}

export async function addGlass(): Promise<void> {
  if (!supabase) throw new Error("Supabase not configured");
  const { data: userData } = await supabase.auth.getUser();
  const user = userData.user;
  if (!user) throw new Error("Not signed in");
  const { error } = await supabase
    .from("water_logs")
    .insert({ user_id: user.id, amount_ml: GLASS_ML });
  if (error) throw error;
}

export async function removeLastGlass(latestId: string | undefined): Promise<void> {
  if (!supabase || !latestId) return;
  const { error } = await supabase.from("water_logs").delete().eq("id", latestId);
  if (error) throw error;
}

function startOfToday(): Date {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d;
}

export function mlToOz(ml: number): number {
  return ml / 29.5735;
}
